<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addBlacklistPopup">{{ $t('add') }}</vs-button>
      </template>
      <vs-divider></vs-divider>

    </vx-card>

    <vx-card id="blacklistDataContainer" :title="$t('blacklist')" class="mb-8 vs-con-loading__container">
      <shared-blacklist-list
        :blacklist="blacklist"
        @customClickDelete="deleteBlacklist"
      ></shared-blacklist-list>
    </vx-card>


    <modal :title="$t('Add Blacklist')" id="addProject" :active.sync="modals.add" size="xl">
      <shared-blacklist-add
        @addBlacklistSuccess="addBlacklistSuccess"
      ></shared-blacklist-add>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addBlacklistButton" color="primary" type="filled" @click.prevent="addBlacklist">{{ $t('save') }}</vs-button>
      </div>
    </modal>

  </div>
</template>

<script>
import Blacklist from '@/models/Blacklist'
import SharedBlacklistList from '@/views/Shared/Blacklist/List'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import Modal from '@/components/Modal'
import SharedBlacklistAdd from '@/views/Shared/Blacklist/Add'

export default {
  name: 'User.Blacklist',
  components: {
    Modal,
    SharedBlacklistAdd,
    SharedBlacklistList
  },
  data () {
    return {
      blacklist: {},
      modals: {
        add: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initBlacklistFormData')
      }
    }
  },
  mounted () {
    this.loadBlacklist(this.initialPage)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_blacklist_table', this.reloadBlacklist)
  },
  methods: {
    reloadBlacklist () {
      this.loadBlacklist()
    },
    async loadBlacklist () {
      this.$vs.loading({container: '#blacklistDataContainer'})
      const response = await Blacklist.all()
      this.blacklist = response.data.data.blacklist
      this.$vs.loading.close('#blacklistDataContainer > .con-vs-loading')
    },
    addBlacklistModal () {
      this.modals.add = true
    },
    addBlacklistPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-blacklist', {}, this.addBlacklistModal)
    },
    async deleteBlacklist (phone) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Blacklist.destroy({ phone })
        this.loadBlacklist()
      }
    },
    addBlacklist () {
      EventBus.$emit('initAddBlacklist')
    },
    addBlacklistSuccess () {
      this.loadBlacklist(this.initialPage)
      this.modals.add = false
    }
  }
}
</script>

<style lang="scss">

</style>
